import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BookingConfirmationTemplateWithDetail } from '../booking-confirmation-template-with-detail';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-booking-confirmation-template-edit',
  templateUrl: './booking-confirmation-template-edit.component.html',
  styleUrls: ['./booking-confirmation-template-edit.component.css']
})
export class BookingConfirmationTemplateEditComponent implements OnInit {

  selectedTemplate!: BookingConfirmationTemplateWithDetail;
  templateForm!: FormGroup;
  @ViewChild("textArea") textArea!: ElementRef;

  constructor(
    public pdfDocumentService: PdfDocumentTemplateService,
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    let templateId = this.pdfDocumentService.selectedConfirmationTemplate.id;
    this.httpService.getBookingConfirmationTemplateById(templateId).subscribe(res => {
      this.selectedTemplate = res;
      this.templateForm = this.builder.group({
        body: this.selectedTemplate.body,
        name: this.selectedTemplate.name
      });
    });
  }

  backtoTheList() {
    this.pdfDocumentService.activeItemId = PdfTemplateViewOption.FINAL_CONFIRMATIONS;
  }

  updateTemplate() {
    this.selectedTemplate.body = this.templateForm.value.body;
    this.httpService.updateBookingConfirmationTemplate(new BookingConfirmationTemplateWithDetail(
      this.selectedTemplate.id,
      this.templateForm.value.name,
      this.templateForm.value.body
    )).subscribe(() => {
      this.toastService.addSuccess("Success", "Template updated");
    }, error => {
      this.toastService.addError("Error", error.error.message);
    });
  }

}
